import React, { useState, useEffect} from "react";
import {
  CalendarNextArrow,
  CalendarPrevArrow,
  ResetIcon,
  closeIcon
} from "../../../utils/icons";
import PropTypes from "prop-types";
import {
  DateRangePickerContainer,
  HeaderContainer,
  StyledBody,
  StyledModal,
} from "../../Manager/Dashboard/style";
import { Modal } from "react-bootstrap";
import { ManagerIconContainer } from "../../Manager/styles";
import {
  Container,
  CalendarHeader,
  Grid,
  Day,
  Button,
  BottomButtons,
  ResetButton,
  DownloadButton,
  DayWrap
} from './style';
import dayjs from "dayjs";

const getDaysInMonth = (year, month) => {
  const date = dayjs(new Date(year, month, 1));
  const days = [];
  let current = date;
  while (current.month() === month) {
    days.push(current);
    current = current.add(1, 'day');
  }
  return days;
};

const CustomDateRangePicker = ({ showModal, onClose, date, stateDateSelected, changeDate, type }) => {
  const today = dayjs().startOf('day');
  const [currentMonth, setCurrentMonth] = useState(today.month());
  const [currentYear, setCurrentYear] = useState(today.year());
  const [startDate, setStartDate] = useState(date);
  const days = getDaysInMonth(currentYear, currentMonth);

  useEffect(() => {
    const referenceDate = date || stateDateSelected || today;
    setCurrentMonth(dayjs(referenceDate).month());
    setCurrentYear(dayjs(referenceDate).year());
  }, [date, showModal]);
  
  const handleMonthChange = (direction) => {
    const newDate = dayjs(new Date(currentYear, currentMonth)).add(direction, 'month');
    const isBeforeToday = newDate.isBefore(today, 'month');
    if (isBeforeToday) return;
    setCurrentMonth(newDate.month());
    setCurrentYear(newDate.year());
  };

  const submitDate = () => {
    changeDate(startDate,type)
  }

  const handleDayClick = (day) => {
    const baseDate =
      type !== "date"
        ? stateDateSelected
          ? dayjs(stateDateSelected).startOf('day')
          : today
        : today;
    if (day.isBefore(baseDate, 'day')) return;
    setStartDate(day);
  };
  
  const resetDates = () => {
    setStartDate(null);
  };

  const isSameDay = (d1, d2) => d1 && d2 && d1.isSame(d2, 'day');
  return (
    <StyledModal
      id="download-popup"
      show={showModal}
      onHide={onClose}
      dialogClassName={"manager-popup"}
      backdropClassName="drop-back"
      isWidth
      isHeight
      maxwidth="468px"
    >
      <Modal.Header style={{ background: "#F8F8F8" }}>
        <HeaderContainer id="download-heading">
          <div className="report-title">
            <span className="header-text">Select Date</span>
          </div>
          <ManagerIconContainer style={{ cursor: "pointer", marginBottom: '16px' }} onClick={onClose}>
            {closeIcon("#F37A65", 14, 14)}
          </ManagerIconContainer>
        </HeaderContainer>
      </Modal.Header>
      <StyledBody id="calendar-container" style={{ background: "#F8F8F8", borderRadius:"0 0 6px 6px" }}>
        <DateRangePickerContainer id="date-range-picker">
          <Container id="date-container">
            <div id="calendar-container" className="calendar-container">
              <CalendarHeader id="calendar-header">
                <Button
                  id="prev-button"
                  onClick={() => handleMonthChange(-1)}
                >
                  {CalendarPrevArrow()}
                </Button>
                <span id="month-name" className="title">
                  {dayjs(new Date(currentYear, currentMonth)).format("MMMM YYYY")}
                </span>
                <Button id="next-prev" onClick={() => handleMonthChange(1)}>
                  {CalendarNextArrow()}
                </Button>
              </CalendarHeader>
              <Grid id="grid-days" style={{padding:"0px 16px",backgroundColor:"transparent"}}>
                {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
                  <div className="day-name-v1" key={day}>{day}</div>
                ))}
              </Grid>
              <DayWrap style={{padding:"0px 16px"}}>
                {
                  // Add empty placeholders before first day
                  Array.from({ length: (days[0].day() + 6) % 7 }).map((_, idx) => (
                    <Day style={{background:"transparent"}} key={`empty-${idx}`} disabled />
                  ))
                }
                {days.map((day) => {
                  const isDisabled =
                    type !== "date"
                      ? stateDateSelected
                        ? day.isBefore(dayjs(stateDateSelected).startOf('day'))
                        : day.isBefore(today)
                      : day.isBefore(today);
                  return (
                    <Day
                      id="days"
                      key={day.toString()}
                      onClick={() => !isDisabled && handleDayClick(day)}
                      isSelected={isSameDay(day, startDate)}
                      disabled={isDisabled}
                    >
                      {day.date()}
                    </Day>
                  );
                })}
              </DayWrap>

            </div>
          </Container>
          <div style={{width:"100%", height:"1px", background:"#EFEFEF", margin:"0 0 16px 0"}}></div>
          <BottomButtons id="bottom-buttons">
            <ResetButton id="reset-dates" onClick={resetDates}>
              <span>{ResetIcon()}</span>
              <span className="reset-text">Reset Dates</span>
            </ResetButton>
            <DownloadButton id="download-buttons" disabled={!startDate} onClick={()=>submitDate(startDate,type)}>
              Confirm
            </DownloadButton>
          </BottomButtons>
        </DateRangePickerContainer>
      </StyledBody>
    </StyledModal>
  );
};

CustomDateRangePicker.propTypes = {
  onClose: PropTypes.func,
  showModal: PropTypes.bool,
  date: PropTypes.object,
  stateDateSelected: PropTypes.object,
  type: PropTypes.string,
  changeDate: PropTypes.func,
  resetDatePopup: PropTypes.func
};

export default CustomDateRangePicker;
